import { render, staticRenderFns } from "./TerminalTicketHistory.vue?vue&type=template&id=e37531be&scoped=true"
import script from "./TerminalTicketHistory.vue?vue&type=script&lang=js"
export * from "./TerminalTicketHistory.vue?vue&type=script&lang=js"
import style0 from "./TerminalTicketHistory.vue?vue&type=style&index=0&id=e37531be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37531be",
  null
  
)

export default component.exports